import { useTranslate } from '@festina-life/ui/hooks'

import { useScenarioContext } from '../../context/scenarioContext'
import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { withLifeErrorBoundary } from '../../libs/withLifeErrorBoundary'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { PretendDeathForm } from './PretendDeathForm'

/**
 * When a scenario and scenario variant is selected on the scenario page a _Pretend death_ command can be created.
 *
 * This opens up a modal where a death date can be enteret. When applied to a scenario variant, the commitment will go in to death registered status, and other death related commands will be available, like ie. _death claims_
 *
 * This command can only be applied to a scenario variant. It is not possible to add to an actual commitment.
 */
function PretendDeathCommandInternal(props: ActionButtonProps) {
  const translate = useTranslate()
  const { variantIdentifier } = useScenarioContext()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const actions = useHook('mutators.life.usePretendDeathActions')({
    tenantId,
    ownerId,
    scenarioId: variantIdentifier?.scenarioId ?? '',
    scenarioVariantId: variantIdentifier?.variantId ?? '',
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="life.PretendDeathCommandData"
      title={translate('pretendDeathModalButton.title')}
      commandDataForm={PretendDeathForm}
      {...props}
      submit={submit}
    />
  )
}

export const PretendDeathCommand = withLifeErrorBoundary(
  PretendDeathCommandInternal,
)
